import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './../common/SafeIcon';
import { COLOR_OF_THE_MONTH } from '../utils/guideData';

const ColorOfMonth = ({ onSelectColor }) => {
  const { month, name, hex, meaning, inspiration, tags } = COLOR_OF_THE_MONTH;

  return (
    <section className="mb-8 sm:mb-12">
      <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
        <span className="h-px w-6 sm:w-8 bg-purple-500" />
        <h3 className="text-[10px] sm:text-xs font-bold text-purple-400 uppercase tracking-[0.25em] sm:tracking-[0.3em]">
          Intelligence Feature
        </h3>
      </div>
      
      <div className="relative group overflow-hidden rounded-xl sm:rounded-2xl md:rounded-[2rem] glass-panel border border-white/10">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-white/[0.02] to-transparent pointer-events-none" />
        
        <div className="flex flex-col lg:flex-row items-stretch">
          <div 
            className="lg:w-1/3 p-6 sm:p-8 md:p-12 flex flex-col justify-between relative overflow-hidden min-h-[200px] sm:min-h-[250px]" 
            style={{ backgroundColor: hex }}
          >
            <div className="relative z-10">
              <span className="text-[8px] sm:text-[9px] md:text-[10px] font-black uppercase tracking-widest text-black/40 mb-1 block">
                Color of the Month
              </span>
              <h2 className="text-3xl sm:text-4xl font-black text-white leading-none tracking-tighter">
                {month.split(' ')[0]}
              </h2>
            </div>
            
            <div className="relative z-10 mt-8 sm:mt-12 lg:mt-0">
              <button
                onClick={() => onSelectColor(hex)}
                className="px-4 sm:px-6 py-2.5 sm:py-3 bg-white/20 hover:bg-white/30 backdrop-blur-md rounded-lg sm:rounded-xl text-[10px] sm:text-xs font-black text-white flex items-center gap-2 transition-all border border-white/20"
              >
                <SafeIcon icon={FiIcons.FiZap} />
                APPLY {hex}
              </button>
            </div>
            
            <div className="absolute -bottom-10 -right-10 text-[80px] sm:text-[100px] md:text-[120px] font-black text-white/10 select-none">
              {month.split(' ')[0][0]}
            </div>
          </div>
          
          <div className="lg:w-2/3 p-6 sm:p-8 md:p-12 space-y-6 sm:space-y-8">
            <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-center gap-2">
                  <SafeIcon icon={FiIcons.FiInfo} className="text-purple-400 text-sm sm:text-base" />
                  <h4 className="text-[10px] sm:text-sm font-black uppercase tracking-widest text-gray-400">
                    The Profile
                  </h4>
                </div>
                <h3 className="text-xl sm:text-2xl font-black text-white">{name}</h3>
                <p className="text-gray-500 text-xs sm:text-sm leading-relaxed">{meaning}</p>
              </div>
              
              <div className="space-y-3 sm:space-y-4">
                <div className="flex items-center gap-2">
                  <SafeIcon icon={FiIcons.FiCompass} className="text-purple-400 text-sm sm:text-base" />
                  <h4 className="text-[10px] sm:text-sm font-black uppercase tracking-widest text-gray-400">
                    The Inspiration
                  </h4>
                </div>
                <p className="text-gray-500 text-xs sm:text-sm leading-relaxed italic">
                  "{inspiration}"
                </p>
              </div>
            </div>
            
            <div className="flex flex-wrap gap-2 pt-3 sm:pt-4 border-t border-white/5">
              {tags.map(tag => (
                <span 
                  key={tag}
                  className="px-2.5 sm:px-3 py-1 bg-white/5 rounded-full text-[8px] sm:text-[10px] font-bold text-gray-400 uppercase border border-white/5"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ColorOfMonth;